// CurrentApplicantLicenceNumber
import { push } from "connected-react-router";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { Header, Paragraph, ErrorWithString, ErrorMark } from "../../components/RegularComponents";
import TopNavigationBar from "../TopNavigationBar";
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from "../../app/errors";
import { ValidateString } from "../../app/utils";
import { setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import { checkLicenceNumberActive } from "../../redux/slice/businessLicenceApplicationSlice";

const MORTGAGE_APPLICATION_PROPERTY = "brokerLicenceNumber";
export const CurrentApplicantLicenceNumber = (props) => {
  const dispatch = useDispatch();

  const agentApplication = useSelector(currentAgentApplicationSelector);

  const [licenceNumberError, setLicenceNumberError] = useState(VALIDATION_ERROR.NO_ERROR);
  const exisitingLicenceNumber =
    agentApplication?.businessLicenceData?.[MORTGAGE_APPLICATION_PROPERTY];
  const [licenceNumber, setLicenceNumber] = useState(exisitingLicenceNumber);
  const [invalidLicenceNumber, setInvalidLicenceNumber] = useState(false);
  const [serverError, setServerError] = useState(false);

  useEffect(() => {
    setLicenceNumber(exisitingLicenceNumber);
  }, [exisitingLicenceNumber]);

  const handleNext = () => {
    const ret2 = ValidateString(licenceNumber, VALIDATION_TYPE.STRING_NON_EMPTY);
    if (ret2 !== VALIDATION_ERROR.NO_ERROR) {
      setLicenceNumberError(ret2);
      return;
    }

    dispatch(checkLicenceNumberActive(licenceNumber))
      .then((isActive) => {
        if (isActive) {
          dispatch(
            setCurrentAgentMortgageProperty({
              key: MORTGAGE_APPLICATION_PROPERTY,
              value: licenceNumber
            })
          );

          const nextPath = ROUTE_PATH.MRA_IS_CANADA_RESIDENT;

          dispatch(
            push({
              pathname: `${ROUTE_PATH.MRA_APP}${nextPath}`
            })
          );
        } else {
          setInvalidLicenceNumber(true);
        }
      })
      .catch((error) => {
        setServerError(true);
        console.error(error);
      });
  };

  return (
    <div className="container">
      {/* Title */}
      <TopNavigationBar {...props} />
      <div className="row">
        <div className="col-xs-12 col-lg-11">
          <Header
            id="broker-next-steps-header"
            header="Enter the applicant's current Nova Scotia Mortgage Broker or Associate Mortgage Broker Licence Number"
          />
          <Paragraph
            id="complete-mortgage-education-text"
            text={[
              "Their current licence will be cancelled when their new application has been approved."
            ]}
          />
        </div>
      </div>

      {/* Licence Number */}
      <div className="row">
        <div className="col-lg-8">
          <div
            className={
              "ns-fieldset" +
              (licenceNumberError && licenceNumberError !== VALIDATION_ERROR.NO_ERROR
                ? " has-error ns-fieldset-message-error"
                : "")
            }
          >
            <fieldset className="ns-fieldset">
              <label
                id={"mortgage-broker-licence-number-label"}
                className="ns-label"
                autoComplete="postal-code"
                htmlFor={"mortgage-broker-licence-number-text"}
              >
                Licence number
              </label>
              {licenceNumberError && licenceNumberError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"mortgage-broker-licence-number-text-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(ERROR_STRING.LICENCE_NUMBER_EMPTY)}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (licenceNumberError && licenceNumberError !== VALIDATION_ERROR.NO_ERROR
                    ? " ns-input--error"
                    : " ns-input")
                }
                id={"mortgage-broker-licence-number-text"}
                name={"mortgage-broker-licence-number-text"}
                value={licenceNumber}
                onChange={(e) => {
                  setLicenceNumber(e.target.value);
                  setLicenceNumberError(VALIDATION_ERROR.NO_ERROR);
                  setInvalidLicenceNumber(false);
                }}
              />
            </fieldset>
          </div>
        </div>
      </div>

      <div className="form-group has-error">
        <button
          className="btn-lg btn-default"
          style={{ marginBottom: "5px" }}
          onClick={handleNext}
          value={"Continue"}
          name={"Continue"}
        >
          {"Continue"}
        </button>{" "}
        {invalidLicenceNumber && ErrorMark()}
        {invalidLicenceNumber && (
          <div className="ns-error-message">
            <span className="ns-visually-hidden">Error:</span>
            {
              "The licence you selected is not active. Only active licenses can be transferred."
            }
          </div>
        )}
        {serverError && ErrorMark()}
        {serverError && (
          <div className="ns-error-message">
            <span className="ns-visually-hidden">Error:</span>
            {"An error occurred while validating the licence number. Please try again."}
          </div>
        )}
      </div>
    </div>
  );
};
